import { Box, Typography } from '@mui/material';
import React from 'react';

export default function HomeGreeting({
  firstName,
  isMobile,
}: {
  firstName?: string;
  isMobile: boolean;
}) {
  return (
    <Box mt={0} mb={isMobile ? 1 : 0}>
      {firstName && (
        <Typography variant={isMobile ? 'h6' : 'body1'} component="div">
          Hi{' '}
          <Box component="span" display="inline-block">
            {firstName}
          </Box>
        </Typography>
      )}
    </Box>
  );
}
